import type { ReactNode } from 'react';

export const symbol_mark_chat_unread: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-240 131-131q-14 14-32.5 6.34Q80-132.31 80-152v-668q0-24 18-42t42-18h399q13.6 0 22.8 9.5Q571-861 569-847q-2 11-10.5 19t-19.5 8H140v600l74-80h606v-315q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v315q0 24-18 42t-42 18H240Zm442-511.12q-32-32.12-32-78T682.12-907q32.12-32 78-32T838-906.88q32 32.12 32 78T837.88-751q-32.12 32-78 32T682-751.12ZM140-820v520-520Z"
		/>
	</svg>
);
